import { makeVar } from '@apollo/client';
import { PdpPlanWithTiers } from '@coverright/data-access/medicare';

export const selectedPdpPlanVar = makeVar<PdpPlanWithTiers | undefined>(undefined);
